import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { WEISCHER } from "../../../constants/itemTypes"
import { PROGRAM_WEISCHERAD_ITEMS } from "../../../constants/state"
import getData from "../../../functions/getData"
import ListItemWeischerContainer from './ListItemWeischerContainer'

const mapStateToProps = (state, ownProps) => ({
    itemData:  getData(state, [PROGRAM_WEISCHERAD_ITEMS, ownProps.itemId])
})

const ListItemDataWeischerContainer = ({
    itemId,
    itemData,
    additionalClass =  false,
    isSelected = false,
    pathnameEdit = false,
    onDeleteItem = false

}) => <ListItemWeischerContainer
    itemType={WEISCHER}
    itemData={itemData}
    additionalClass={additionalClass}
    isSelected={isSelected}
    pathnameEdit={pathnameEdit}
    onDelete={() => onDeleteItem(itemId)}
/>

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemDataWeischerContainer)